import { QueryKey } from '@/Config/api/queryKey';

export const EMAIL_NS = 'integration:email';
export const EMAIL_INTEGRATION_NAME = 'email' as const;
export const EMAIL_QUERY_KEY = [QueryKey.integration.get, EMAIL_INTEGRATION_NAME] as const;
export const EMAIL_FORWARDING_POLL_INTERVAL_MS = 15000;
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Deep-link to the domain/DNS section of the Email channel docs.
export const DOMAIN_DOCS_URL =
  'https://docs.quickchat.ai/channels/email#send-replies-from-your-own-domain';

// Mirrors REPLY_DELAY_MINUTES_CHOICES in telegramquickchat/email/consts.py.
export const EMAIL_REPLY_DELAY_MINUTES = [0, 1, 2, 3, 5, 10, 20] as const;
